// external imports
import React from 'react'
// local imports
import logoSrc from './logo.jpg'

const Logo = props => <img className='logo' src={logoSrc} height={130} style={{ margin: 15, alignSelf: 'center' }}/>

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/index.js